import axios from "axios";
import CommonDropzone from "components/common/CommonDropzone";
import CommonTextField from "components/common/CommonTextField";
import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { generateURLOptions } from "URLOptions";
import {
  UPLOAD_VIRTUAL_COMMUTE_AUDIO,
  UPLOAD_VIRTUAL_COMMUTE_IMAGE,
} from "URLRoutes";

const EditVirtualCommute = ({ isOpen, onClose, item, onSubmit }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [audioURL, setAudioURL] = useState("");
  const [imageURL, setImageURL] = useState("");

  useEffect(() => {
    if (item) {
      setTitle(item.title);
      setDescription(item.description);
      setAudioURL(item.audio);
      setImageURL(item.image);
    }
  }, [item]);

  useEffect(() => {
    if (!isOpen) {
      setTitle("");
      setDescription("");
      setAudioURL("");
      setImageURL("");
    }
  }, [isOpen]);

  const uploadImage = async (image) => {
    const formData = new FormData();
    formData.append("image", image);
    try {
      const response = await axios.post(
        UPLOAD_VIRTUAL_COMMUTE_IMAGE,
        formData,
        {
          headers: generateURLOptions("multipart/form-data"),
        }
      );
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      setImageURL(response.data?.data);
    } catch (error) {
      console.error("Upload Virtual Commute Image Error: ", error);
      alert(error);
    }
  };

  const uploadAudio = async (audio) => {
    const formData = new FormData();
    formData.append("audio", audio);
    try {
      const response = await axios.post(
        UPLOAD_VIRTUAL_COMMUTE_AUDIO,
        formData,
        {
          headers: generateURLOptions("multipart/form-data"),
        }
      );
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      setAudioURL(response.data?.data);
    } catch (error) {
      console.error("Upload Virtual Commute Audio Error: ", error);
      alert(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-lg font-semibold">Edit Virtual Commute Item</h2>
            <p className="text-sm text-gray-600">{item?.title ?? ""}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <IoCloseOutline size={24} />
          </button>
        </div>

        {/* Body */}
        <div className="space-y-4">
          <CommonTextField
            label="Virtual Commute Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Virtual Commute Title"
          />

          <CommonTextField
            label="Virtual Commute Description"
            value={description}
            multiline={true}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Virtual Commute Description"
          />

          {/* Image Upload Area */}
          <div>
            <p className="mb-1 font-semibold text-sm text-gray-800">Image</p>
            <div className="flex gap-3 items-start mb-3">
              {imageURL && (
                <img
                  src={imageURL}
                  alt="Mindfulness Upload"
                  className="w-2/5 h-auto object-cover rounded-lg"
                />
              )}
              <CommonDropzone
                title="Image"
                value={imageURL}
                dropFile={uploadImage}
              />
            </div>
          </div>

          {/* Audio Upload Area */}
          <div>
            <p className="mb-1 font-semibold text-sm text-gray-800">Audio</p>
            {audioURL && (
              <audio src={audioURL} controls className="w-full mb-3" />
            )}
            <CommonDropzone value={audioURL} dropFile={uploadAudio} />
          </div>

          <p className="text-xs text-center text-gray-600">
            The Play Duration is automatically calculated based on the audio
            uploaded.
          </p>
        </div>

        {/* Footer */}
        <div className="flex justify-between mt-6">
          <button
            onClick={onClose}
            className="w-1/2 mr-2 bg-gray-200 text-gray-800 py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={() =>
              onSubmit({
                itemId: item?._id,
                title,
                description,
                audio: audioURL,
                image: imageURL,
              })
            }
            type="submit"
            className="w-1/2 ml-2 bg-blue-600 text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-blue-700"
          >
            Update VC Item
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditVirtualCommute;
